<template>
    <div class="profile-page">
        <section class="section-profile-cover section-shaped my-0">
            <div class="shape shape-style-1 bg-gradient-info shape-skew">
                <span style="background: rgba(220, 101, 104, 0.21)"></span>
                <span></span>
                <span></span>
                <span style="background: #54ADE1"></span>
                <span style="background: rgba(128, 200, 146, 0.32)"></span>
                <span style="background: rgba(238, 232, 33, 0.22)"></span>
                <span style="background: rgba(255, 255, 255, 0.05)"></span>
            </div>
        </section>
        <section class="section section-skew">
            <div class="container">
                <card shadow class="card-profile mt--400" no-body>
                    <div class="px-4">
                        <div class="row justify-content-left">
                            <div class="col-lg-3 order-lg-2">
                                <div class="card-profile-image">
                                    <a href="#">
                                        <img v-lazy="'img/logos/inter_dk3.png'">
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div class="text-center mt-5">
                            <h3>InterCollege
                            </h3>
                            <div class="h6 font-weight-300"><i class="ni location_pin mr-2"></i>Aalborg, Denmark</div>
                            <div class="h6 mt-4"><i class="ni business_briefcase-24 mr-2"></i>is a social enterprise within the field of</div>
                            <div><i class="ni education_hat mr-2"></i>Education and Capacity Development.</div>
                        </div>
                        <div class="mt-5 py-5 border-top">
                            <div class="row justify-content-center">
                                <div class="col-lg-11 s_1">
                                    <p>The organization was established in Denmark in 2010 with the mission to stimulate global progress built upon international understanding and coherence.</p>
                                    <p>
                                    InterCollege aim is to innovate education through:
                                    </p>
                                    <p class="pl-2">
                                        - Facilitating bespoke education<br>
                                        - Being a counterpart to educational providers<br>
                                        - Mobilizing and connecting People, Ideas and Resources<br> 
                                    </p>
                                    <p>
                                    Since its foundation, InterCollege has been active in vocational education. InterCollege supports VET-institutions in Europe to find relevant traineeships to their students in Denmark and facilitate their social and cultural integration. Together with 10 pre-vocational institutions in Denmark, InterCollege sends students and staff in learning experiences abroad.     
                                    </p>
                                    <p>
                                    With several strategic partnerships, 400 students mobilities and over 15.000 training days per year, InterCollege is committed to create quality and international dimensions in education.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </card>
            </div>
        </section>
        <section class="section section-skew">
            <div class="container">
                <card shadow class="card-profile mt-0" no-body>
                    <div class="px-4">
                        <div class="row justify-content-left">
                            <div class="col-lg-3 order-lg-2">
                                <div class="card-profile-image">
                                    <a href="#">
                                        <img v-lazy="'img/logos/inter_uk.png'">
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div class="text-center mt-5">
                            <h3>InterCollege (UK)
                            </h3>
                            <div class="h6 font-weight-300"><i class="ni location_pin mr-2"></i>Derby, United Kingdom</div>
                            <div class="h6 mt-4"><i class="ni business_briefcase-24 mr-2"></i>is a social enterprise based in</div>
                            <div><i class="ni education_hat mr-2"></i>the city of Derby, UK.</div>
                        </div>
                        <div class="mt-5 py-5 border-top">
                            <div class="row justify-content-center">
                                <div class="col-lg-11 s_1">
                                    <p>The organisation was formed in 2014 with the vision of developing a participative global society: beginning at a local level.</p>
                                    <p>
                                    The aim of InterCollege (UK) is to provide inclusive non-formal learning opportunities that foster an inter-culturally aware society of active citizens, with tolerance to diversity and a sense of global responsibility. 
                                    </p>
                                    <p>
                                    The activities of InterCollege (UK) are based around achieving the following objectives:
                                    </p>
                                    <p class="pl-2">
                                        - Increase increase engagement in non- formal learning and international mobility.<br>
                                        - Promote and endorse the benefits and value of s non- formal learning and international mobility.<br>
                                        - Create an international network of partner organisations alongside a strong connection with local organisations and stakeholders.<br> 
                                    </p>
                                    <p>
                                    The organisation works with partner organisations both locally and throughout Europe to provide access to international educational opportunities, including vocational training placements in another country.     
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </card>
            </div>
        </section>
        <section class="section section-skew">
            <div class="container">
                <card shadow class="card-profile mt-0" no-body>
                    <div class="px-4">
                        <div class="row justify-content-left">
                            <div class="col-lg-3 order-lg-2">
                                <div class="card-profile-image">
                                    <a href="#">
                                        <img v-lazy="'img/logos/c4g.png'">
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div class="text-center mt-5">
                            <h3>C4G
                            </h3>
                            <div class="h6 font-weight-300"><i class="ni location_pin mr-2"></i>Lisbon, Portugal</div>
                            <div class="h6 mt-4"><i class="ni business_briefcase-24 mr-2"></i>is a Portuguese VET provider</div>
                            <div><i class="ni education_hat mr-2"></i>specialized in VET training within Erasmus+ and other programmes</div>
                        </div>
                        <div class="mt-5 py-5 border-top">
                            <div class="row justify-content-center">
                                <div class="col-lg-11 s_1">
                                    <p>In the last years has been partnering with over 30 schools in the Lisbon region and centre of Portugal doing activities related with students development. Hosting of students coming from various countries in Europe to do internships within erasmus+ Ka1 VET is a key VET activity it tries to enhance.</p>
                                    <p>
                                    Here, experiences vary from work based learning activities in many sectors and can go from 2 weeks to up to 6 months. Also, job shadowing for teachers and staff is a must and very good way of learning and benchmarking methodologies. 
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </card>
            </div>
        </section>
        <section class="section section-skew">
            <div class="container">
                <card shadow class="card-profile mt-0" no-body>
                    <div class="px-4">
                        <div class="row justify-content-left">
                            <div class="col-lg-3 order-lg-2">
                                <div class="card-profile-image">
                                    <a href="#">
                                        <img v-lazy="'img/logos/interb2.png'">
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div class="text-center mt-5">
                            <h3>InterBildung e.V
                            </h3>
                            <div class="h6 font-weight-300"><i class="ni location_pin mr-2"></i>Ranstadt, Germany</div>
                            <div class="h6 mt-4"><i class="ni business_briefcase-24 mr-2"></i>is a non-profit registered association</div>
                            <div><i class="ni education_hat mr-2"></i>established in 2017 in Ranstadt, Germany</div>
                        </div>
                        <div class="mt-5 py-5 border-top">
                            <div class="row justify-content-center">
                                <div class="col-lg-11 s_1">
                                    <p>The primary goal of InterBildung is to promote education through international cooperation of people, ideas and resources. It is aimed to provide interactive exchange of students and trainers, to encourage international mobility in education, intercultural dialogue and mutual understanding. The association fosters exchange of values, innovation, experience as well as acquire of new skills, knowledge and qualifications.</p>
                                    <p>
                                    Within the framework of European Programs and especially Erasmus+ VET Mobility projects, InterBildung is acting as intermediary organization engaged in supporting vocational education in collaboration with institutions, schools, companies and partner organizations. InterBildung is fully oriented to understand the needs and requirements of all parties involved in these invaluable mobility projects and to propose the best solutions. 
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </card>
            </div>
        </section>
        <section class="section section-skew">
            <div class="container">
                <card shadow class="card-profile mt-0" no-body>
                    <div class="px-4">
                        <div class="row justify-content-left">
                            <div class="col-lg-3 order-lg-2">
                                <div class="card-profile-image">
                                    <a href="#">
                                        <img v-lazy="'img/logos/adept2.png'">
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div class="text-center mt-5">
                            <h3>ADEPT
                            </h3>
                            <div class="h6 font-weight-300"><i class="ni location_pin mr-2"></i>Bucharest, Romania</div>
                            <div class="h6 mt-4"><i class="ni business_briefcase-24 mr-2"></i>is a non-governmental organisation</div>
                            <div><i class="ni education_hat mr-2"></i>established in 2015 in Bucharest, Romania</div>
                        </div>
                        <div class="mt-5 py-5 border-top">
                            <div class="row justify-content-center">
                                <div class="col-lg-11 s_1">
                                    <p>ADEPT's (Asociatia de Dezvoltare a Europei Prin Tineri) vision is to provide its members and the local community  with oppportunities for personal and professional development.</p>
                                    <p>
                                    ADEPT’s purpose is to strenghten the European identity amongst young people and enhance their active participation in the local and European society by delivering activities such as seminars, trainings, local, national and international meetings, youth exchanges that promote the benefits and power of a united, responsible and engaged society.
                                    </p>
                                    <p>
                                    In the past years, ADEPT has also been partnering with different other stakeholders across the globe in projects related to Global Responsibility, women empowerment, gender equality, cultural learning, as well development of the VET sector.  
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </card>
            </div>
        </section>
        <section class="section section-skew">
            <div class="container">
                <card shadow class="card-profile mt-0" no-body>
                    <div class="px-4">
                        <div class="row justify-content-left">
                            <div class="col-lg-3 order-lg-2">
                                <div class="card-profile-image">
                                    <a href="#">
                                        <img v-lazy="'img/logos/anespo2.png'">
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div class="text-center mt-5">
                            <h3>ANESPO
                            </h3>
                            <div class="h6 font-weight-300"><i class="ni location_pin mr-2"></i>Lisbon, Portugal</div>
                            <div class="h6 mt-4"><i class="ni business_briefcase-24 mr-2"></i>is a non-profit organization</div>
                            <div><i class="ni education_hat mr-2"></i>established in February 1991 in Portugal</div>
                        </div>
                        <div class="mt-5 py-5 border-top">
                            <div class="row justify-content-center">
                                <div class="col-lg-11 s_1">
                                    <p>ANESPO – National Association of Professional Schools represents over 140 Professional Schools in Portugal, most of them owned by Companies, Business Associations, Foundations, Cooperatives, Trade Unions and Local Authorities. The schools deliver professional courses, attended by about 40.000 students, awarding a diploma of level 4 (European Union’s qualification framework), corresponding to middle staff.</p>
                                    <p>
                                    Professional Schools enhance development strategies in their contexts, actively working with regional and local authorities and other economic and social stakeholders, and establishing close links with business environment and employers, thus enabling on-the-job training as a strong component in education offer.
                                    </p>
                                    <p>
                                    ANESPO takes a strategic partner role with government, namely with education, labor and professional training ministries, as well as with other official bodies, several public community and private institutions, and economic and social stakeholders, namely social partners. 
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </card>
            </div>
        </section>
        <section class="section section-skew">
            <div class="container">
                <card shadow class="card-profile mt-0" no-body>
                    <div class="px-4">
                        <div class="row justify-content-left">
                            <div class="col-lg-3 order-lg-2">
                                <div class="card-profile-image">
                                    <a href="#">
                                        <img v-lazy="'img/logos/kocaeli.png'">
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div class="text-center mt-5">
                            <h3>KPDoNE
                            </h3>
                            <div class="h6 font-weight-300"><i class="ni location_pin mr-2"></i>Kocaeli Region, Turkey</div>
                            <div class="h6 mt-4"><i class="ni business_briefcase-24 mr-2"></i>is a public body</div>
                            <div><i class="ni education_hat mr-2"></i>with a focus on educational institutions</div>
                        </div>
                        <div class="mt-5 py-5 border-top">
                            <div class="row justify-content-center">
                                <div class="col-lg-11 s_1">
                                    <p>
                                    Kocaeli Provincial Directorate of National Education (KPDoNE) is a public body that has under its 
                                    administration 39 pre-school institutions, 229 special needs institutions, 281 primary schools, 235 secondary schools, 62 vocational secondary schools, 4 vocational education centres, 6 teachers’ guest houses, 12 Public Training Centres, 3 Counselling and Research Centres in its region. 
                                    </p>
                                    <p>
                                    Although KPDoNE focuses on educational institutions, their target groups are school students aged 6 to 18, as well as young people aged between 18-30 who are out of school and having distance education. KPDoNE is in close relation with youth groups which organised by schools.
                                    </p>
                                    <p>
                                    KPDoNE is in close cooperation with youth NGOs in Kocaeli region and offers them support and counselling regarding their educational programmes. 
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </card>
            </div>
        </section>
    </div>
</template>
<script>
export default {};
</script>
<style>
.s_1 > p, .s_1 > ul {
    font-size:14px !important
}
.s_1 > ul {
    color: #525f7f !important
}
</style>
